import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Sparkles, X, Phone, MessageCircle, CalendarDays, MapPin, Users, Layers } from 'lucide-react'
import { WhatsAppShareOptionsModal } from '../../../organisms/Dashboard/whatsappShareModalShared'
import { useAppDispatch, useAppSelector } from '../../../../Redux/Hooks'
import SubmitButton from '../../../atoms/Login/SubmitButton'
import {
  createEventAPI,
  createEventNameAPI,
  deleteEventAPI,
  deleteEventNameAPI,
  getEventNamesAPI,
  sendEventDataToMemberOnWhatsAppAPI,
  updateEventAPI,
} from '../../../../Redux/ApiCalls/Dashboard/EventAPI'
import { getAllMembers } from '../../../../Redux/ApiCalls/Dashboard/MembersAPI'
import { showErrorToast, showSuccessToast } from '../../../atoms/Utlis/Toast'
import DeleteIconPNG from '../../../../assets/Icons/deleteIconGradient.svg'
import DeleteEventPopup from '../../../atoms/Dashboard/Events/DeleteEventPopup'
import Errortext from '../../../atoms/Utlis/Errortext'
import PermissionGate from '../../../atoms/Utlis/PermissionGate'
import { usePermissions } from '../../../../hooks/usePermissions'
import { CalendarSubEvents, EventType } from '../../../../Data/event.dto'
import SubCalendarEventModal from '../../../atoms/Dashboard/Events/SubCalendarEventModal'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import { Member } from '../../../../Data/member.dto'
import WhatsAppIconPNG from '../../../../assets/Icons/SocialMedia/whatsAppTest.png'
import { IMAGE_CDN } from '../../../../config/config'
import { device } from '../../../atoms/Utlis/media'
import { trackClarityEvent } from '../../../../analytics/ClarityAnalytics'
import { CLARITY_EVENTS } from '../../../../analytics/EventTypes'
import {
  ModalShell,
  ModalHero,
  HeroGlow,
  HeroRow,
  HeroText,
  HeroBadge,
  ModalTitle,
  ModalSubtitle,
  CloseBtn,
  ModalBody,
  CardLabel,
  FieldInput,
  PrimaryBtn,
  gradient,
  SectionHeader,
  SectionTitleRow,
  StepBadge,
  SectionTitleBlock,
  SectionTitle,
  FieldHint,
  EmptyStateBox,
  EmptyStateTitle,
  EmptyStateText,
} from './eventModalSharedStyles'
interface ModalProps {
  isOpen: boolean
  onClose: () => void
  onSubmit: (eventData: EventData) => void
  selectedSlot: SlotInfo | null
  initialShareOpen?: boolean // NEW: when true and an existing event is loaded, auto-open the WhatsApp share popup
}

interface EventData {
  eventName: string
  dateTime: Date
  members: string[]
}

interface SlotInfo {
  start: Date
  end: Date
}

const EventCreateModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  selectedSlot,
  initialShareOpen = false, // NEW
}) => {
  const [eventName, setEventName] = useState('')
  const [addEventName, setAddEventName] = useState('')
  const [eventMembers, setEventMembers] = useState<number[]>([])
  const [selectedMembers, setSelectedMembers] = useState<number[]>([])
  const [selectedEventName, setSelectedEventName] = useState<any>()
  const [startDateTime, setStartDateTime] = useState('')
  const [endDateTime, setEndDateTime] = useState('')
  const { members, isMemberFetched } = useAppSelector((state) => state.member)
  const { eventNames } = useAppSelector((state) => state.event)
  const { currentEvent } = useAppSelector((state) => state.event)
  const { branches, selectedBranch } = useAppSelector((state) => state.auth)
  const [branchId, setBranchId] = useState<number | string>(selectedBranch?.id || '')
  const selectionRef = useRef<HTMLSelectElement>(null)
  const [addMemberMenu, setAddMemberMenu] = useState(false)
  const [addEventNameMenu, setAddEventNameMenu] = useState(false)
  const [deleteMember, setDeleteMember] = useState<number[]>([])
  const [subEvents, setSubEvents] = useState<CalendarSubEvents[]>([])
  const [locationList, setLocationList] = useState<string[]>([])
  const selectMenuRef = useRef<HTMLDivElement>(null)
  const eventNameDropdownRef = useRef<HTMLDivElement>(null)
  const eventNameFieldRef = useRef<HTMLDivElement>(null)
  const memberDropdownRef = useRef<HTMLDivElement>(null)
  const memberFieldRef = useRef<HTMLDivElement>(null)
  const [deletedSubEvents, setDeletedSubEvents] = useState<number[]>([])
  const [currentSubEvent, setCurrentSubEvent] =
    useState<CalendarSubEvents | null>(null)

  const [isSubEventModal, setIsSubEventModal] = useState(false)
  const [isEventNameModal, setEventNameModal] = useState(false)
  const [isUpdate, setIsUpdate] = useState(false)
  // const navigate = useNavigate();
  const [deletePopup, setDeletePopUp] = useState(false)
  const [eventDeletePopup, setEventDeletePopup] = useState(false)
  const [showError, setShowError] = useState(false)
  const [eventNameId, setEventNameId] = useState(0)
  const [shareLoading, setShareLoading] = useState(false);
  const [whatsappOptionsOpen, setWhatsappOptionsOpen] = useState(false);
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!isMemberFetched) {
      dispatch(getAllMembers())
    }
  }, [dispatch, isMemberFetched])

  useEffect(() => {
    if (currentEvent) {
      // const start = new Date(currentEvent.start);
      // const end = new Date(currentEvent.end);
      // // console.log();
      const start = new Date(currentEvent.start)
      const end = new Date(currentEvent.end)
      const padZero = (num: number) => num.toString().padStart(2, '0')
      currentEvent.members.forEach((member) => {
        // eventMembers.push(member.member);
        setEventMembers((pre) => [...pre, member.member])
        // console.log("pushing member")
      })
      const formatedStart = `${start.getFullYear()}-${padZero(
        start.getMonth() + 1
      )}-${padZero(start.getDate())}T${padZero(start.getHours())}:${padZero(
        start.getMinutes()
      )}`
      const formatedEnd = `${end.getFullYear()}-${padZero(
        end.getMonth() + 1
      )}-${padZero(end.getDate())}T${padZero(end.getHours())}:${padZero(
        end.getMinutes()
      )}`
      // // console.log(start);
      setIsUpdate(true)
      setStartDateTime(formatedStart)
      setSubEvents(currentEvent.sub_events)
      setEndDateTime(formatedEnd)
      setEventName(currentEvent.title)
      setSelectedEventName(currentEvent.title)
      setBranchId((currentEvent as any).branch_id ? String((currentEvent as any).branch_id) : '')
      setDeletePopUp(false)
      setEventDeletePopup(false)
    } else if (selectedSlot) {
      setBranchId(selectedBranch?.id ? String(selectedBranch.id) : '')
      const start = new Date(selectedSlot.start)
      const end = new Date(selectedSlot.end)
      const padZero = (num: number) => num.toString().padStart(2, '0')

      const formatedStart = `${start.getFullYear()}-${padZero(
        start.getMonth() + 1
      )}-${padZero(start.getDate())}T${padZero(start.getHours())}:${padZero(
        start.getMinutes()
      )}`
      const formatedEnd = `${end.getFullYear()}-${padZero(
        end.getMonth() + 1
      )}-${padZero(end.getDate())}T${padZero(end.getHours())}:${padZero(
        end.getMinutes()
      )}`
      // // console.log(start);
      setStartDateTime(formatedStart)
      setEndDateTime(formatedEnd)
      setSelectedMembers([])
    }
    return () => {
      // dispatch(clearCurrentEvent());
      setEventName('')
      setSelectedEventName('')
      setDeleteMember([])
      setSubEvents([])
      setStartDateTime('')
      setEndDateTime('')
      setSelectedMembers([])
      setDeleteMember([])
      setIsUpdate(false)
      setShowError(false)
      setEventMembers([])
    }
  }, [selectedSlot, currentEvent])

  // NEW: auto-open the WhatsApp share popup when the parent asks for "share mode"
  useEffect(() => {
    if (isOpen && initialShareOpen && currentEvent) {
        setWhatsappOptionsOpen(true)
    }
    if (!isOpen) {
        setWhatsappOptionsOpen(false)
    }
}, [isOpen, initialShareOpen, currentEvent])

  // Handle click outside for dropdowns
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node

      // Close event name dropdown if clicked outside
      if (
        addEventNameMenu &&
        eventNameDropdownRef.current &&
        eventNameFieldRef.current &&
        !eventNameDropdownRef.current.contains(target) &&
        !eventNameFieldRef.current.contains(target)
      ) {
        setAddEventNameMenu(false)
      }

      // Close member dropdown if clicked outside
      if (
        addMemberMenu &&
        memberDropdownRef.current &&
        memberFieldRef.current &&
        !memberDropdownRef.current.contains(target) &&
        !memberFieldRef.current.contains(target)
      ) {
        setAddMemberMenu(false)
      }
    }

    // Add event listener when any dropdown is open
    if (addEventNameMenu || addMemberMenu) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    // Cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [addEventNameMenu, addMemberMenu])

  const handleMember = (id: number) => {
    if (deleteMember.includes(id)) {
      setDeleteMember((pre) => pre.filter((member) => member !== id))
      eventMembers.push(id)
    } else {
      if (selectedMembers.includes(id)) {
        let flag = false
        subEvents.forEach((event) => {
          event.members.forEach((member) => {
            if (member.member === id) {
              flag = true
            }
          })
        })
        if (flag) showErrorToast('Please remove first from sub event.')
        else setSelectedMembers((pre) => pre.filter((val) => val !== id))
      } else {
        setSelectedMembers((pre) => [...pre, id])
      }
    }
  }

  const validEventName = (name: string) => {
    if (name.length > 0 && name.length < 35) {
      return true
    } else return false
  }

  const validSubEvents = (subEvents: CalendarSubEvents[]) => {
    if (subEvents.length > 0) return true
    else return false
  }

  const uniqueSortedIds = (ids: number[]) =>
    Array.from(new Set(ids)).sort((a, b) => a - b)

  /** Returns true if the update form differs from `currentEvent` (submit should run). */
  const hasUpdateChanges = (): boolean => {
    if (!currentEvent || !isUpdate) return true

    if (deletedSubEvents.length > 0) return true

    if (
      String(selectedEventName ?? '').trim() !==
      String(currentEvent.title ?? '').trim()
    )
      return true

    const originalMembers = uniqueSortedIds(
      currentEvent.members.map((m) => m.member)
    )
    const currentMembers = uniqueSortedIds([
      ...selectedMembers,
      ...eventMembers,
    ])
    if (
      originalMembers.length !== currentMembers.length ||
      originalMembers.some((id, i) => id !== currentMembers[i])
    )
      return true

    if (subEvents.some((e) => e.id < 0)) return true

    const normalizeSubEvent = (se: CalendarSubEvents) => ({
      sub_event_name: (se.sub_event_name ?? '').trim(),
      start_date: String(se.start_date ?? ''),
      start_time: String(se.start_time ?? '').trim(),
      end_date: String(se.end_date ?? ''),
      end_time: String(se.end_time ?? '').trim(),
      location: (se.location ?? '').trim(),
      memberIds: uniqueSortedIds(se.members.map((m) => m.member)),
    })

    const originalSubs = currentEvent.sub_events.filter((s) => s.id >= 0)
    const origById = new Map(
      originalSubs.map((s) => [s.id, normalizeSubEvent(s)])
    )

    const currentPersisted = subEvents.filter((s) => s.id >= 0)
    if (currentPersisted.length !== origById.size) return true

    const currentIdSet = new Set(currentPersisted.map((s) => s.id))
    for (const id of Array.from(origById.keys())) {
      if (!currentIdSet.has(id)) return true
    }

    for (const sub of currentPersisted) {
      const baseline = origById.get(sub.id)
      if (!baseline) return true
      const now = normalizeSubEvent(sub)
      if (
        baseline.sub_event_name !== now.sub_event_name ||
        baseline.start_date !== now.start_date ||
        baseline.start_time !== now.start_time ||
        baseline.end_date !== now.end_date ||
        baseline.end_time !== now.end_time ||
        baseline.location !== now.location ||
        baseline.memberIds.length !== now.memberIds.length ||
        baseline.memberIds.some((id, i) => id !== now.memberIds[i])
      )
        return true
    }

    return false
  }

  const handleSubmit = () => {
    const hasEventName = !!selectedEventName
    const hasSubEvents = validSubEvents(subEvents)
    if (!hasEventName || !hasSubEvents) {
      setShowError(true)
      return
    }
    setShowError(false)

    if (isUpdate && currentEvent && !hasUpdateChanges()) {
      return
    }

    {
      console.log(eventName, subEvents)
      // console.log(isUpdate)
      // console.log(subEventsData)

      if (isUpdate && currentEvent) {
        let subEventsData = subEvents.map((event) => {
          if (event.id < 0)
            return {
              sub_event_name: event.sub_event_name,
              start_date: event.start_date,
              start_time: event.start_time,
              end_date: event.end_date,
              end_time: event.end_time,
              location: event.location,
              member_ids: event.members.map((member) => member.member),
            }
          else
            return {
              sub_event_id: event.id,
              sub_event_name: event.sub_event_name,
              start_date: event.start_date,
              start_time: event.start_time,
              end_date: event.end_date,
              end_time: event.end_time,
              location: event.location,
              member_ids: event.members.map((member) => member.member),
            }
        })

        const updatePayload: any = {
          business_event_id: currentEvent.id,
          title: selectedEventName,
          event_member: [...selectedMembers, ...eventMembers],
          sub_events: subEventsData,
          delete_sub_events: deletedSubEvents,
        }
        if (branchId) {
          updatePayload.branch_id = Number(branchId)
        } else if (branchId === '') {
          updatePayload.branch_id = null
        }
        dispatch(updateEventAPI(updatePayload))
      }
      // dispatch(updateEventAPI({ event_id: currentEvent.id, start_date: startDate, end_date: endDate, start_time: startTime, end_time: endTime, title: eventName, location: eventLocation, member_ids: [...selectedMembers, ...eventMembers] }))
      else {
        let subEventsData = subEvents.map((event) => ({
          sub_event_name: event.sub_event_name,
          start_date: event.start_date,
          start_time: event.start_time,
          end_date: event.end_date,
          end_time: event.end_time,
          location: event.location,
          sub_event_member_id: event.members.map((member) => member.member),
        }))

        const createPayload: any = {
          title: selectedEventName,
          event_member_id: selectedMembers,
          sub_events: subEventsData,
        }
        if (branchId) {
          createPayload.branch_id = Number(branchId)
        }
        dispatch(createEventAPI(createPayload))
      }
      console.log(selectedMembers)

      setAddMemberMenu(false)
      onClose()
    }

    // onSubmit(eventData);
  }
  const handleDeleteMember = (id: number) => {
    let flag = false
    subEvents.forEach((event) => {
      event.members.forEach((member) => {
        if (member.member === id) {
          flag = true
        }
      })
    })
    if (flag) showErrorToast('Please remove first from sub event.')
    else if (!deleteMember.includes(id) && eventMembers.includes(id)) {
      setDeleteMember([...deleteMember, id])
      setEventMembers((pre) => pre.filter((member) => member !== id))
    }
  }

  const handleDeleteEvent = (id: number) => {
    dispatch(deleteEventAPI({ id }))
    // dispatch(clearCurrentEvent());

    onClose()
  }
  const handleButtonClick = (buttonAction: () => void) => {
    setAddMemberMenu(false)
    buttonAction()
  }
  const handleAddSubEvents = (subEvent: CalendarSubEvents) => {
    console.log(subEvent)
    let filteredSubEvents = subEvents.filter((e) => e.id !== subEvent.id)
    setSubEvents([...filteredSubEvents, subEvent])
    const notIncludedmembers = subEvent.members.filter(
      (e) =>
        !selectedMembers.includes(e.member) && !eventMembers.includes(e.member)
    )
    setSelectedMembers((pre) => [
      ...pre,
      ...notIncludedmembers.map((member) => member.id),
    ])
    setIsSubEventModal(false)
  }
  const handleRemoveSubEvents = (subEvent: CalendarSubEvents) => {
    setSubEvents((pre) => pre.filter((e) => e.id !== subEvent.id))
  }

  const handleDeleteSubEvent = (id: number) => {
    setDeletedSubEvents((pre) => [...pre, id])
    setSubEvents((pre) => pre.filter((e) => e.id !== id))
  }

  // const handleShare = async () => {
  //     if (currentEvent) {
  //         try {
  //             const htmlContent = createHtmlContent(currentEvent, members);
  //             const blob = new Blob([htmlContent], { type: 'text/html' });
  //             const url = URL.createObjectURL(blob);

  //             const iframe = document.createElement('iframe');
  //             iframe.style.visibility = 'hidden';
  //             iframe.src = url;
  //             document.body.appendChild(iframe);

  //             iframe.onload = async () => {
  //                 const pdfDoc = new jsPDF();
  //                 const canvas = await html2canvas(iframe.contentDocument!.body, { scale: 2 });
  //                 const imgData = canvas.toDataURL('image/png');
  //                 pdfDoc.addImage(imgData, 'PNG', 0, 0, 210, 297);

  //                 // Cleanup
  //                 document.body.removeChild(iframe);
  //                 URL.revokeObjectURL(url);

  //                 // Generate PDF and get URL
  //                 const pdfBlob = pdfDoc.output('blob');
  //                 const pdfUrl = URL.createObjectURL(pdfBlob);
  //                 console.log(pdfUrl);
  //                 // Open WhatsApp sharing dialog
  //                 window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent('Check out this event PDF: ' + pdfUrl)}`, '_blank');
  //             };
  //         } catch (error) {
  //             console.error('Failed to generate or share PDF:', error);
  //         }
  //     }
  // };
  const handleShare = () => {
    if (currentEvent) {
      console.log('whatsApp called')
      const message = formatEventData(currentEvent)
      const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
        message
      )}`
      window.open(whatsappUrl, '_blank')
    }
  }
  const getMemberData = (id: any, membersList: Member[]) => {
    if (!id || !membersList || membersList.length === 0) return null
    if (typeof id === 'object' && id !== null && (id.phone_number || id.name)) {
      return id as Member
    }
    const numericId = typeof id === 'number' ? id : parseInt(String(id), 10)
    return (
      membersList.find((member) => {
        const mId = typeof member.id === 'number' ? member.id : parseInt(String(member.id), 10)
        return mId === numericId || String(member.id) === String(id)
      }) || null
    )
  }

  const formatPhoneNumber = (memberData: any): string | null => {
    const rawPhone = memberData?.phone_number || memberData?.phone || memberData?.mobile
    if (!rawPhone) return null
    const cleanPhone = String(rawPhone).trim().replace(/\D/g, '')
    if (!cleanPhone) return null
    const countryCode = String(memberData.country_code || '91').replace(/\D/g, '') || '91'
    if (cleanPhone.length > 10 && cleanPhone.startsWith(countryCode)) {
      return `+${cleanPhone}`
    }
    return `+${countryCode}${cleanPhone}`
  }

  const formatEventData = (event: EventType): string => {
    let message = `\u{1F4C5} *Event Title*: ${event.title}\n\n`

    const allSubEvents = event.sub_events && event.sub_events.length > 0
      ? event.sub_events
      : [{
          id: 0,
          sub_event_name: event.title,
          location: '',
          start_date: event.start?.split('T')?.[0] || '',
          start_time: event.start?.split('T')?.[1] || '',
          end_date: event.end?.split('T')?.[0] || '',
          end_time: event.end?.split('T')?.[1] || '',
          members: event.members || [],
        }]

    allSubEvents.forEach((subEvent, index) => {
      const hasLocation = Boolean(subEvent.location?.trim())
      const mapsUrl = hasLocation
        ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
          subEvent.location.trim()
        )}`
        : ''
      message += `*Sub-Event ${index + 1}*\n`
      message += `    \u{1F4DB} *Name*: ${subEvent.sub_event_name}\n`
      if (hasLocation) {
        message += `    \u{1F4CD} *Location*: ${subEvent.location}\n`
        message += `    \u{1F517} *Map*: ${mapsUrl}\n`
      }
      message += `    \u{1F5D3}\u{FE0F} *Start Date*: ${subEvent.start_date}\n`
      message += `    \u{23F0} *Start Time*: ${subEvent.start_time}\n`
      message += `    \u{1F5D3}\u{FE0F} *End Date*: ${subEvent.end_date}\n`
      message += `    \u{23F0} *End Time*: ${subEvent.end_time}\n`

      // Check subEvent members first, then fall back to event members
      const candidateMembers = (subEvent.members && subEvent.members.length > 0)
        ? subEvent.members
        : (event.members && event.members.length > 0
          ? event.members
          : [...eventMembers, ...selectedMembers])

      if (candidateMembers && candidateMembers.length > 0) {
        let membersBlock = ''
        candidateMembers.forEach((member: any) => {
          const memberId = member?.member ?? member?.id ?? member
          const memberData = getMemberData(memberId, members)
          if (memberData) {
            membersBlock += `        - ${memberData.name} (${memberData.job_type})\n`
          }
        })
        if (membersBlock) {
          message += `    \u{1F465} *Members*:\n${membersBlock}`
        }
      }

      message += '\n'
    })

    return message
  }

  const sendToWhatsApp = async (event: EventType) => {
    setShareLoading(true);
    try {
      // Ensure we have members loaded
      let activeMembers = members;
      if (!activeMembers || activeMembers.length === 0) {
        try {
          const result = await dispatch(getAllMembers()).unwrap();
          if (Array.isArray(result)) {
            activeMembers = result;
          } else if (result?.data && Array.isArray(result.data)) {
            activeMembers = result.data;
          }
        } catch (err) {
          console.error("Could not fetch members in sendToWhatsApp:", err);
        }
      }

      // Collect all sub-events or create fallback
      const subEventsToProcess = (event.sub_events && event.sub_events.length > 0)
        ? event.sub_events
        : [{
            id: 0,
            sub_event_name: event.title,
            location: '',
            start_date: event.start?.split('T')?.[0] || '',
            start_time: event.start?.split('T')?.[1] || '',
            end_date: event.end?.split('T')?.[0] || '',
            end_time: event.end?.split('T')?.[1] || '',
            members: event.members || [],
          }];

      let totalRecipients = 0;
      const promises = subEventsToProcess.map(async (subEvent) => {
        // Look for members on sub-event, or fall back to event-level members
        const rawMembers = (subEvent.members && subEvent.members.length > 0)
          ? subEvent.members
          : (event.members && event.members.length > 0
            ? event.members
            : [...eventMembers, ...selectedMembers]);

        if (rawMembers.length > 0) {
          const to: string[] = [];

          rawMembers.forEach((memberObj: any) => {
            const memberId = memberObj?.member ?? memberObj?.id ?? memberObj;
            const memberData = getMemberData(memberId, activeMembers);
            const formattedPhone = memberData ? formatPhoneNumber(memberData) : null;
            if (formattedPhone && !to.includes(formattedPhone)) {
              to.push(formattedPhone);
            }
          });

          if (to.length === 0) return null;
          totalRecipients += to.length;

          const payload = {
            "to": to,
            "event_title": event?.title,
            "sub_event": subEvent?.sub_event_name,
            "location": subEvent?.location,
            "start_date": subEvent?.start_date,
            "start_time": subEvent?.start_time,
            "end_date": subEvent?.end_date,
            "end_time": subEvent?.end_time,
            "message": formatEventData(event),
          };
          return sendEventDataToMemberOnWhatsAppAPI(payload);
        }
        return null;
      }).filter(Boolean);

      if (promises.length === 0 || totalRecipients === 0) {
        showErrorToast("No member phone numbers found for this event. Please ensure team members have a valid phone number.");
        setShareLoading(false);
        return;
      }

      await Promise.all(promises);

      showSuccessToast("Event message sent to members successfully!!!");
      trackClarityEvent(CLARITY_EVENTS.CALENDAR_EVENT_SHARED, {
        event_id: event.id,
        event_title: event.title,
        sub_events_count: event.sub_events?.length || 1,
        total_members: totalRecipients,
        share_method: "whatsapp",
      });
      setWhatsappOptionsOpen(false);
    } catch (error: any) {
      showErrorToast("Error in sending message to members!!");
    } finally {
      setShareLoading(false);
    }
  }

  /* DIRECT WHATSAPP OPEN */
  const handleDirectWhatsAppOpen = (event: EventType) => {
    try {
      // Format event data into a message
      const message = formatEventData(event);

      // Open WhatsApp with pre-filled message using api.whatsapp.com to prevent redirect encoding drops
      const whatsappUrl = `https://api.whatsapp.com/send/?text=${encodeURIComponent(message)}`;
      window.open(whatsappUrl, "_blank");

      trackClarityEvent(CLARITY_EVENTS.CALENDAR_EVENT_SHARED, {
        event_id: event.id,
        event_title: event.title,
        sub_events_count: event.sub_events.length,
        total_members: event.sub_events.reduce((sum, subEvent) => sum + subEvent.members.length, 0),
        share_method: "whatsapp_direct",
      });

      setWhatsappOptionsOpen(false);
    } catch (error) {
      console.error('Error opening WhatsApp:', error);
      showErrorToast("Error opening WhatsApp");
    }
  };

  const handleEventNameClick = (event: any) => {
    setSelectedEventName(event.event_name)
  }
  const handleCloseEventNameModal = () => {
    setEventNameModal(false)
  }
  const onChangeData = (name: string, value: string) => {
    if (name === 'add_event_name' && value.length <= 25) setAddEventName(value)
  }
  const handleAddEventButton = () => {
    const trimmedName = addEventName.trim()
  
    if (!trimmedName) {
      return showErrorToast('Event name should not be empty')
    }
  
    // Client-side duplicate check against already-loaded event names
    const isDuplicate = eventNames?.some(
      (event: any) =>
        event?.event_name?.trim().toLowerCase() === trimmedName.toLowerCase()
    )
    if (isDuplicate) {
      showErrorToast('Event name is already taken, please select another.')
      return
    }
  
    dispatch(createEventNameAPI({ event_name: trimmedName }))
      .unwrap()
      .then(() => {
        dispatch(getEventNamesAPI())
        setEventNameModal(false)
        setAddEventName('')
      })
      .catch((err) => {
        const rawMessage =
          typeof err === 'string'
            ? err
            : err?.error?.stringify_error ||
              err?.stringify_error ||
              err?.message ||
              ''
  
        if (rawMessage.toLowerCase().includes('duplicate entry')) {
          showErrorToast('Event name is already taken, please select another.')
        } else {
          showErrorToast('Something went wrong. Please try again.')
        }
      })
  }
  const handleDeleteEventName = (eventNameId: number) => {
    dispatch(deleteEventNameAPI([eventNameId]))
      .unwrap()
      .then(() => {
        dispatch(getEventNamesAPI())
      })
      .catch((err) => {
        showErrorToast(err)
      })
    setDeletePopUp(false)
    // }
  }

  // const generatePDF = (event: EventType) => {
  //     const doc = new jsPDF();

  //     doc.setFontSize(16);
  //     doc.text(event.title, 10, 10);

  //     event.sub_events.forEach((subEvent, index) => {
  //         doc.setFontSize(14);
  //         doc.text(`${index + 1}. ${subEvent.sub_event_name}`, 10, 20 + index * 10);

  //         doc.setFontSize(12);
  //         doc.text(`Location: ${subEvent.location}`, 10, 30 + index * 10);
  //         doc.text(`Start Time: ${subEvent.start_date}`, 10, 40 + index * 10);
  //         doc.text(`End Time: ${subEvent.start_time}`, 10, 50 + index * 10);

  //     });
  //     return doc;
  // }
  if (!isOpen) return null

  return selectedSlot || currentEvent ? (
    <ModalOverlay onClick={onClose}>
      <ModalShell onClick={(e) => e.stopPropagation()}>
        <ModalHero>
          <HeroGlow />
          <HeroRow>
            <HeroText>
              <HeroBadge>
                <Sparkles size={10} />
                Event Calendar
              </HeroBadge>
              <ModalTitle>{currentEvent ? 'Edit Event' : 'Schedule Event'}</ModalTitle>
              <ModalSubtitle>
                {currentEvent
                  ? 'Update the event type, day schedule, and team.'
                  : 'Pick an event type, add day schedules (sub-events), then assign your team.'}
              </ModalSubtitle>
            </HeroText>
            <CloseBtn type="button" onClick={onClose}>
              <X size={18} />
            </CloseBtn>
          </HeroRow>
        </ModalHero>

        <ModalBody>
          {branches && branches.length > 0 && (
            <div style={{ marginBottom: 18 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#334155', marginBottom: 6 }}>
                Studio Branch (Optional)
              </label>
              <select
                value={branchId}
                onChange={(e) => setBranchId(e.target.value)}
                style={{
                  width: '100%',
                  padding: '10px 14px',
                  borderRadius: 10,
                  border: '1px solid #cbd5e1',
                  fontSize: 14,
                  color: '#1e293b',
                  background: '#fff',
                  outline: 'none',
                }}
              >
                <option value="">All Branches / Main Studio (HQ)</option>
                {branches.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.branch_name} {b.city ? `(${b.city})` : ''}
                  </option>
                ))}
              </select>
            </div>
          )}
          <InputNameConatiner>
          <SectionHeader>
            <SectionTitleRow>
              <StepBadge>1</StepBadge>
              <SectionTitleBlock>
                <SectionTitle>
                  Event type <RequiredStar>*</RequiredStar>
                </SectionTitle>
                <FieldHint>
                  Choose what kind of shoot this is (Wedding, Birthday, etc.). You can add a new type if it is missing.
                </FieldHint>
              </SectionTitleBlock>
            </SectionTitleRow>
          </SectionHeader>
          <SelectionMenuListConatiner>
            <SelectionField
              ref={eventNameFieldRef}
              onClick={() => {
                !eventNames
                  ? showErrorToast('No Event Available.')
                  : setAddEventNameMenu((pre) => !pre)
              }}
            >
              {selectedEventName ? (
                <SelectedValue>{selectedEventName}</SelectedValue>
              ) : (
                <PlaceholderText>Tap to select event type</PlaceholderText>
              )}
              <SelectMemberLabel
                ref={selectionRef}
                defaultValue={'Add Event'}
              />
            </SelectionField>
            <Errortext
              show={showError && !selectedEventName}
              message="Please select or add an event type to continue."
            />
            <MemberMenuConatriner>
              {addEventNameMenu && (
                <AddMemberListConatiner ref={eventNameDropdownRef}>
                  <DropdownHeader>
                    <AddEventButton
                      onClick={() => {
                        setEventNameModal(true)
                        setAddEventNameMenu(false)
                      }}
                    >
                      + Add Event Type
                    </AddEventButton>
                  </DropdownHeader>
                  <MemberList>
                    {eventNames &&
                      [...eventNames].reverse().map((event: any) => (
                        <EventNameListItem
                          key={event?.id}
                          onClick={() => {
                            handleEventNameClick(event)
                            setAddEventNameMenu(false)
                          }}
                          htmlFor={`event${event?.id}`}
                        >
                          <MemberData>
                            <MemberText>
                              <DropdownItemRow>
                                <MemberName>{event?.event_name}</MemberName>
                                {event?.is_created === true && (
                                  <DeleteEventConatiner2>
                                    <DeleteIcon
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        setDeletePopUp(true)
                                        setEventNameId(event?.id)
                                      }}
                                      src={DeleteIconPNG}
                                    />
                                  </DeleteEventConatiner2>
                                )}
                              </DropdownItemRow>
                            </MemberText>
                          </MemberData>
                        </EventNameListItem>
                      ))}
                  </MemberList>
                </AddMemberListConatiner>
              )}
            </MemberMenuConatriner>
          </SelectionMenuListConatiner>
        </InputNameConatiner>
        <FormField>
          {isSubEventModal && (
            <SubCalendarEventModal
              locationList={locationList}
              setLocationList={setLocationList}
              currentLength={subEvents.length}
              addSubEvent={handleAddSubEvents}
              currentSubEvent={currentSubEvent}
              onClose={() => setIsSubEventModal(false)}
              startInitialDate={startDateTime}
              endInitialDate={endDateTime}
            />
          )}
          {isEventNameModal && (
            <Modal
              onClick={(e) => {
                e.stopPropagation()
                handleCloseEventNameModal()
              }}
            >
              <EventNameModalShell onClick={(e) => e.stopPropagation()}>
                <ModalHero>
                  <HeroGlow />
                  <HeroRow>
                    <HeroText>
                      <HeroBadge>
                        <Sparkles size={11} />
                        Event type
                      </HeroBadge>
                      <ModalTitle>Create event type</ModalTitle>
                      <ModalSubtitle>
                        Add a reusable name you can pick whenever you schedule this kind of event.
                      </ModalSubtitle>
                    </HeroText>
                    <CloseBtn
                      type="button"
                      onClick={handleCloseEventNameModal}
                      aria-label="Close"
                    >
                      <X size={18} />
                    </CloseBtn>
                  </HeroRow>
                </ModalHero>
                <EventNameModalBody>
                  <EventNameField>
                    <CardLabel htmlFor="add-event-name">Event type name</CardLabel>
                    <FieldInput
                      type="text"
                      id="add-event-name"
                      placeholder="e.g. Wedding, Birthday, Corporate"
                      name="name"
                      onChange={(e) =>
                        onChangeData('add_event_name', e.target.value)
                      }
                      value={addEventName}
                      autoFocus
                    />
                    <FieldHint>
                      Keep it short — this name appears in the calendar and share messages.
                    </FieldHint>
                    <Errortext
                      show={
                        addEventName.trim().length > 0 &&
                        Boolean(
                          eventNames?.some(
                            (event: any) =>
                              event?.event_name?.trim().toLowerCase() ===
                              addEventName.trim().toLowerCase()
                          )
                        )
                      }
                      message="This event name is already taken, please choose another."
                    />
                  </EventNameField>
                  <EventNameActions>
                    <EventNameCancelBtn
                      type="button"
                      onClick={handleCloseEventNameModal}
                    >
                      Cancel
                    </EventNameCancelBtn>
                    <PrimaryBtn type="button" onClick={handleAddEventButton}>
                      Create
                    </PrimaryBtn>
                  </EventNameActions>
                </EventNameModalBody>
              </EventNameModalShell>
            </Modal>
          )}
          {eventNames && deletePopup && (
            <DeleteEventPopup
              Delete={() => handleDeleteEventName(eventNameId)}
              cancel={() => setDeletePopUp(false)}
            />
          )}

          <InputContainer>
            <SectionHeader>
              <SectionTitleRow>
                <StepBadge>2</StepBadge>
                <SectionTitleBlock>
                  <SectionTitle>
                    Day schedules <RequiredStar>*</RequiredStar>
                    <SubEventCount> ({subEvents.length})</SubEventCount>
                  </SectionTitle>
                  <FieldHint>
                    Each sub-event is one shoot day — set its name, date, duration, location, and crew. Add at least one.
                  </FieldHint>
                </SectionTitleBlock>
              </SectionTitleRow>
              {subEvents.length <= 10 && (
                <AddSubEventButton
                  type="button"
                  onClick={() => {
                    setCurrentSubEvent(null)
                    setIsSubEventModal(true)
                  }}
                >
                  + Add day
                </AddSubEventButton>
              )}
            </SectionHeader>

            {subEvents.length === 0 ? (
              <EmptyStateBox>
                <EmptyStateIconWrap>
                  <Layers size={22} />
                </EmptyStateIconWrap>
                <EmptyStateTitle>No day schedules yet</EmptyStateTitle>
                <EmptyStateText>
                  Tap “Add day” to create your first schedule — for example Engagement day, Wedding day, or Reception.
                </EmptyStateText>
                <AddSubEventButton
                  type="button"
                  onClick={() => {
                    setCurrentSubEvent(null)
                    setIsSubEventModal(true)
                  }}
                >
                  + Add your first day
                </AddSubEventButton>
              </EmptyStateBox>
            ) : (
              <SubEventsList>
                {subEvents.map((event, index) => (
                  <SubEventNameContainer
                    key={`${event.id}-${event.sub_event_name}`}
                    onClick={() => {
                      setCurrentSubEvent(event)
                      setIsSubEventModal(true)
                    }}
                  >
                    <SubEventCardBody>
                      <SubEventCardTop>
                        <SubEventIndex>Day {index + 1}</SubEventIndex>
                        {currentEvent && event.id >= 0 ? (
                          <DeleteIcon
                            src={DeleteIconPNG}
                            onClick={(e) => {
                              e.stopPropagation()
                              handleDeleteSubEvent(event.id)
                            }}
                          />
                        ) : (
                          <CloseButtonSubEvent
                            onClick={(e) => {
                              e.stopPropagation()
                              handleRemoveSubEvents(event)
                            }}
                          >
                            &times;
                          </CloseButtonSubEvent>
                        )}
                      </SubEventCardTop>
                      <SubEventNameText>{event.sub_event_name}</SubEventNameText>
                      <SubEventMetaRow>
                        <SubEventMetaItem>
                          <CalendarDays size={13} />
                          <span>
                            {event.start_date}
                            {event.start_time ? ` · ${event.start_time.slice(0, 5)}` : ''}
                          </span>
                        </SubEventMetaItem>
                        {event.location ? (
                          <SubEventMetaItem>
                            <MapPin size={13} />
                            <span>{event.location}</span>
                          </SubEventMetaItem>
                        ) : null}
                        <SubEventMetaItem>
                          <Users size={13} />
                          <span>
                            {event.members?.length || 0} member
                            {(event.members?.length || 0) === 1 ? '' : 's'}
                          </span>
                        </SubEventMetaItem>
                      </SubEventMetaRow>
                      <SubEventTapHint>Tap to edit details</SubEventTapHint>
                    </SubEventCardBody>
                  </SubEventNameContainer>
                ))}
              </SubEventsList>
            )}
          </InputContainer>
          <Errortext
            message="Please add at least 1 day schedule (sub-event) before creating the event."
            show={showError && !validSubEvents(subEvents)}
          />
        </FormField>
        <ModalDateConatiner>
          <MemberSelecetionConatiner>
            <SectionHeader>
              <SectionTitleRow>
                <StepBadge>3</StepBadge>
                <SectionTitleBlock>
                  <SectionTitle>
                    Event team
                    <SubEventCount>
                      {' '}
                      ({selectedMembers.length + eventMembers.length})
                    </SubEventCount>
                  </SectionTitle>
                  <FieldHint>
                    Optional — assign photographers or staff to the overall event. You can also assign people on each day schedule.
                  </FieldHint>
                </SectionTitleBlock>
              </SectionTitleRow>
            </SectionHeader>
            <SelectedMemberConatiner>
              {selectedMembers.length === 0 && eventMembers.length === 0 ? (
                <EmptyMembersHint>
                  No team members assigned yet. Use the field below if you want to add people at the event level.
                </EmptyMembersHint>
              ) : (
                <SelectedMembersList>
                  {currentEvent &&
                    members &&
                    eventMembers.length > 0 &&
                    members.map(
                      (member) =>
                        eventMembers.includes(parseInt(member.id)) && (
                          <SelectedMemberDataConatiner key={`ev-${member.id}`}>
                            <SelectedMemberData>
                              <MemberData>
                                <MeberProfileImage
                                  src={`${IMAGE_CDN}/${member.profile_image}`}
                                />
                                <MemberText>
                                  <MemberName>{member.name}</MemberName>
                                  <MemberRole>{member.job_type}</MemberRole>
                                </MemberText>
                              </MemberData>
                              <DeleteIcon
                                onClick={(e) =>
                                  handleButtonClick(() =>
                                    handleDeleteMember(parseInt(member.id))
                                  )
                                }
                                src={DeleteIconPNG}
                              />
                            </SelectedMemberData>
                          </SelectedMemberDataConatiner>
                        )
                    )}
                  {members &&
                    members.map(
                      (member) =>
                        selectedMembers.includes(parseInt(member.id)) && (
                          <SelectedMemberDataConatiner key={`sel-${member.id}`}>
                            <SelectedMemberData>
                              <MemberData>
                                <MeberProfileImage
                                  src={`${IMAGE_CDN}/${member.profile_image}`}
                                />
                                <MemberText>
                                  <MemberName>{member.name}</MemberName>
                                  <MemberRole>{member.job_type}</MemberRole>
                                </MemberText>
                              </MemberData>
                              <RemoveMemberButton
                                onClick={() => handleMember(parseInt(member.id))}
                              >
                                &times;
                              </RemoveMemberButton>
                            </SelectedMemberData>
                          </SelectedMemberDataConatiner>
                        )
                    )}
                </SelectedMembersList>
              )}
            </SelectedMemberConatiner>
            <SelectionMenuListConatiner>
              <SelectionField
                ref={memberFieldRef}
                onClick={() => {
                  !eventNames
                    ? showErrorToast('No Members Available.')
                    : setAddMemberMenu((pre) => !pre)
                }}
              >
                {selectedMembers.length > 0 ? (
                  <SelectedValue>
                    {selectedMembers.length} member
                    {selectedMembers.length > 1 ? 's' : ''} selected
                  </SelectedValue>
                ) : (
                  <PlaceholderText>Tap to add team members (optional)</PlaceholderText>
                )}
                <SelectMemberLabel
                  ref={selectionRef}
                  defaultValue={'Add Member'}
                />
              </SelectionField>
              <MemberMenuConatriner>
                {addMemberMenu && (
                  <MemberDropdownList ref={memberDropdownRef}>
                    <MemberList>
                      {members &&
                        members.map(
                          (member) =>
                            !eventMembers.includes(parseInt(member.id)) && (
                              <MemberListItem
                                key={member.id}
                                htmlFor={`member${member.id}`}
                              >
                                <MemberData>
                                  <MeberProfileImage
                                    src={`${IMAGE_CDN}/${member.profile_image}`}
                                  />
                                  <MemberText>
                                    <MemberName>{member.name}</MemberName>
                                    <MemberRole>{member.job_type}</MemberRole>
                                  </MemberText>
                                </MemberData>
                                <MemberSelectButton
                                  id={`member${member.id}`}
                                  type="checkbox"
                                  onChange={() => {
                                    handleMember(parseInt(member.id))
                                  }}
                                  checked={selectedMembers.includes(
                                    parseInt(member.id)
                                  )}
                                ></MemberSelectButton>
                              </MemberListItem>
                            )
                        )}
                    </MemberList>
                  </MemberDropdownList>
                )}
              </MemberMenuConatriner>
            </SelectionMenuListConatiner>
          </MemberSelecetionConatiner>
        </ModalDateConatiner>

        {/* Add more members as needed */}
        <SubmitConatiner>
          {currentEvent && (
            <ShareButton disabled={shareLoading} onClick={() => setWhatsappOptionsOpen(true)}>
              {shareLoading ? <>Loading....</> : <>
                <WhatsAppIcon src={WhatsAppIconPNG} />
                Share via Whatsapp</>}
            </ShareButton>
          )}
          <SubmitButton
            text={currentEvent ? 'Update' : 'Create'}
            width={270}
            needArrow={false}
            onClick={handleSubmit}
            active={Boolean(currentEvent && !hasUpdateChanges())}
          />
          {currentEvent && (
            <>
              {eventDeletePopup && (
                <DeleteEventPopup
                  Delete={() => handleDeleteEvent(currentEvent.id)}
                  cancel={() => setEventDeletePopup(false)}
                />
              )}
              <PermissionGate permission="events.delete">
                <DeleteEventConatiner onClick={() => setEventDeletePopup(true)}>
                  Delete Event
                </DeleteEventConatiner>
              </PermissionGate>
            </>
          )}
        </SubmitConatiner>
        </ModalBody>
      </ModalShell>

      {whatsappOptionsOpen && currentEvent && (
        <WhatsAppShareOptionsModal
          badge={currentEvent.title || "Event"}
          subtitle="Choose how you want to share this event"
          onClose={() => setWhatsappOptionsOpen(false)}
          loading={shareLoading}
          zIndex={10001}
          options={[
            {
              title: "Open WhatsApp",
              description: "Open WhatsApp and share event data",
              icon: <MessageCircle size={22} />,
              onClick: () => handleDirectWhatsAppOpen(currentEvent),
            },
            {
              title: "Send direct to Members",
              description: "Send event details directly to member phone numbers.",
              icon: <Phone size={22} />,
              showSpinner: true,
              onClick: () => sendToWhatsApp(currentEvent),
            },
          ]}
        />
      )}
    </ModalOverlay>
  ) : null
}

export default EventCreateModal
const breakpoints = {
  mobile: '480px',
  tablet: '768px',
  desktop: '1024px',
}

const Input = styled.input`
  padding-top: 10px;
  width: 98%;
  color: black;
  font-size: 18px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  border: none;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus {
    outline: none;
  }

  @media (max-width: ${breakpoints.mobile}) {
    padding: 7px;
    font-size: 0.9rem;
  }
`

const Modal = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(4px);
  padding: 16px;

  @media (max-width: ${breakpoints.mobile}) {
    padding: 12px;
  }
`

const EventNameModalShell = styled(ModalShell)`
  max-width: 440px;
`

const EventNameModalBody = styled.div`
  padding: 20px 24px 22px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const EventNameField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const EventNameActions = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  ${PrimaryBtn} {
    flex: 1;
    width: auto;
  }
`

const EventNameCancelBtn = styled.button`
  flex: 0 0 auto;
  padding: 0 20px;
  height: 46px;
  border-radius: 12px;
  border: 1px solid rgba(23, 23, 23, 0.12);
  background: #fff;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: rgba(23, 23, 23, 0.65);
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    border-color: rgba(201, 77, 170, 0.25);
    color: #c94daa;
  }
`

const CloseButton = styled.span`
  position: absolute;
  top: 24px;
  right: 24px;
  color: #64748b;
  font-size: 28px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #0f172a;
  }
`
const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
`

const InputNameConatiner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 16px;
  border: 1px solid rgba(23, 23, 23, 0.06);
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.04);
`
const ModalDateConatiner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 16px;
  border: 1px solid rgba(23, 23, 23, 0.06);
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.04);
`
const SelectMemberLabel = styled.select`
  display: none;
`
const MemberSelecetionConatiner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 18px;
`
const SelectedMemberConatiner = styled.div``
const SelectionMenuListConatiner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: left;
`

const SelectionField = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid rgba(23, 23, 23, 0.1);
  background: #fafafa;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: rgba(201, 77, 170, 0.3);
    box-shadow: 0 4px 14px rgba(201, 77, 170, 0.08);
  }
`

const PlaceholderText = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.4);
`

const SelectedValue = styled.span`
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #171717;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const DropdownHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 18px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
`

const AddEventButton = styled.button`
  padding: 7px 14px;
  border-radius: 10px;
  border: none;
  background: ${gradient};
  color: white;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(201, 77, 170, 0.2);
  transition: transform 0.15s ease;
  &:hover { transform: translateY(-1px); }
`

const DropdownItemRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`
const SelectMemberHeading = styled.p`
  font-family: Urbanist;
  font-size: 18px;
  font-weight: 600;
  line-height: 18px;
  text-align: left;
  margin: 0;
  color: #0f172a;
`
const MemberMenuConatriner = styled.div`
  position: relative;
  width: 100%;
`
const AddMemberListConatiner = styled.div`
  position: absolute;
  top: calc(100% + -19px);
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid rgba(15, 23, 42, 0.12);
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.16);
  padding: 12px 0;
  z-index: 120;
  max-height: 260px;
  overflow: hidden;
`

const MemberDropdownList = styled(AddMemberListConatiner)`
  top: auto;
  bottom: calc(100% + 8px);
`

const SelectMemberHeadingConatiner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
const MemberList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 6px;
  max-height: 208px;
  padding: 6px 8px;
  overflow: auto;
`
const MemberData = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`
const MemberName = styled.p`
  font-family: Urbanist;
  font-size: 16px;
  font-weight: 700;
  line-height: 23px;
  text-align: left;
  margin: 0;
  color: #0f172a;
`
const MemberRole = styled.p`
  font-family: Urbanist;
  font-size: 14px;
  font-weight: 500;
  line-height: 23px;
  text-align: left;

  margin: 0;
  color: #64748b;
`
const MemberListItem = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 14px;
  border-radius: 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(15, 23, 42, 0.05);
  }
`
const EventNameListItem = styled.label`
  // display: flex;
  width: 100%;
  padding: 10px 18px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(15, 23, 42, 0.05);
  }
`
const MemberText = styled.div`
  margin: 0px 10px 0px 10px;
  width: 100%;
  /* white-space: nowrap; */
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const MemberSelectButton = styled.input`
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-right: 10px;
  border: 2px solid transparent;
  background: 
    linear-gradient(#fff, #fff) padding-box,
    linear-gradient(133.16deg, #FFC951 -4.52%, #CE56B0 107.63%) border-box;
  border-radius: 5px;
  position: relative;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: #fff;

  &:checked {
    width: 21px;
    background: linear-gradient(144.01deg, rgba(255, 201, 81, 0.8) 0%, rgba(206, 86, 176, 0.8) 100%);
    border: 2px solid transparent;
  }

  &:checked::after {
    content: '';
    position: absolute;
    top: -1px;
    left: 5px;
    width: 6px;
    height: 12px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`

const MeberProfileImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  flex-shrink: 0;
  object-fit: cover;
`

const SelectedMembersList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
`

const SelectedMemberDataConatiner = styled.div`
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 14px;
  padding: 12px;
  background: #f8fafc;
`
const SelectedMemberData = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`
const SubmitConatiner = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  padding-top: 8px;
`
const RemoveMemberButton = styled.button`
  border: none;
  background: rgba(148, 163, 184, 0.2);
  color: #475569;
  font-size: 18px;
  font-weight: 600;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;

  &:hover {
    background: rgba(15, 23, 42, 0.12);
    color: #0f172a;
  }
`
const DeleteIcon = styled.img`
  height: 20px;
  width: 20px;
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease;

  &:hover {
    transform: scale(1.05);
    opacity: 0.85;
  }
`

const DeleteEventConatiner2 = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #94a3b8;
  &:hover {
    color: #c94daa;
  }
`

const DeleteEventConatiner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Urbanist, sans-serif;
  cursor: pointer;
  min-width: 220px;
  padding: 12px 18px;
  background: linear-gradient(164deg, #ef4444 0%, #dc2626 100%);
  color: white;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  height: 48px;
  border-radius: 14px;

  @media ${device.tablet} {
    font-size: 15px;
    min-width: 200px;
  }
`

const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 24px;
  background-color: #ffffff;
  border-radius: 20px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 20px 36px rgba(15, 23, 42, 0.08);
`

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const SubEventsList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 14px;
`

const SubEventCount = styled.span`
  font-weight: 600;
  color: rgba(23, 23, 23, 0.45);
`

const EmptyStateIconWrap = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c94daa;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(201, 77, 170, 0.16);
`

const EmptyMembersHint = styled.p`
  margin: 0;
  padding: 12px 14px;
  border-radius: 12px;
  background: #fafafa;
  border: 1px solid rgba(23, 23, 23, 0.06);
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.45;
  color: rgba(23, 23, 23, 0.55);
`

const AddSubEventButton = styled.button`
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 700;
  padding: 9px 14px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  background: linear-gradient(133deg, #ffc951 0%, #c94daa 130%);
  color: white;
  white-space: nowrap;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(201, 77, 170, 0.2);
  transition: transform 0.15s ease;
  &:hover { transform: translateY(-1px); }
`

const SubEventNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  padding: 14px 16px;
  border: 1px solid rgba(15, 23, 42, 0.1);
  border-radius: 14px;
  background: #fafafa;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

  &:hover {
    border-color: rgba(201, 77, 170, 0.35);
    background: #fff;
    box-shadow: 0 10px 24px rgba(201, 77, 170, 0.1);
  }
`

const SubEventCardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`

const SubEventCardTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`

const SubEventIndex = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(201, 77, 170, 0.1);
  color: #c94daa;
  font-family: Montserrat, sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
`

const SubEventNameText = styled.p`
  margin: 0;
  font-family: Urbanist, sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
  word-break: break-word;
`

const SubEventMetaRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const SubEventMetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  color: rgba(23, 23, 23, 0.55);
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 500;
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

const SubEventTapHint = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: rgba(201, 77, 170, 0.75);
`

const CloseButtonSubEvent = styled.span`
  color: #94a3b8;
  font-size: 22px;
  font-weight: 600;
  cursor: pointer;
  line-height: 1;
  padding: 0 2px;

  &:hover {
    color: #0f172a;
  }
`

const ShareButton = styled.button`
  min-width: 220px;
  padding: 12px 18px;
  background: linear-gradient(160deg, #16a34a 0%, #22c55e 100%);
  color: white;
  font-family: Urbanist, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
  cursor: pointer;
  height: 48px;
  border: none;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${device.tablet} {
    font-size: 15px;
    min-width: 200px;
  }
`

const WhatsAppIcon = styled.img`
  height: 24px;
  width: 24px;
  margin-right: 8px;
`
const RequiredStar = styled.span`
  color: #e53935;
  margin-left: 2px;
`